var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupporting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3333 17.5V15.8334C13.3333 13.9924 11.841 12.5 10 12.5H5.00001C3.15906 12.5 1.66667 13.9924 1.66667 15.8334V17.5M13.3333 2.60669C14.8035 2.98783 15.8302 4.31458 15.8302 5.83336C15.8302 7.35213 14.8035 8.67889 13.3333 9.06002M18.3333 17.5V15.8334C18.3322 14.3143 17.3042 12.9881 15.8333 12.6084",
    stroke: "#165B3D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16667 5.83333C4.16667 7.67305 5.66029 9.16667 7.50001 9.16667C9.33972 9.16667 10.8333 7.67305 10.8333 5.83333C10.8333 3.99362 9.33972 2.5 7.50001 2.5C5.66029 2.5 4.16667 3.99362 4.16667 5.83333V5.83333",
    stroke: "#165B3D",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupporting);
export default __webpack_public_path__ + "static/media/supporting.e6fd90d9e53373b89732907909c68e02.svg";
export { ForwardRef as ReactComponent };